import axiosInstance from "../Interceptors/ResponseInterceptor";

// /api/stakeholder-mapping/stakeholders/add
export const createRowForTable = async (table, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(`/api/mastertables/${table}`, {
        data,
      });
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const deleteRowBycolumnInMaster = async (tableName, column, id) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("gettig", tableName, column, id);
      const response = await axiosInstance.delete(
        `/api/mastertables/${tableName}/${column}/${id}`
      );
      console.log("giving", response.data);
      resolve(response.data);
    } catch (error) {
      console.error("Error deleting stakeholder:", error);
      reject(error);
    }
  });
};

export const getAllMasterTables = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/mastertables`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};

export const getRowsByTableName = async (name, page, pageSize) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/mastertables/${name}?page=${page}&pageSize=${pageSize}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
export const getMetadataByTableName = async (name) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/mastertables/${name}/metadata`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};

export async function UpdateTableData(body, tableName, id) {
  try {
    const response = await axiosInstance.patch(`/api/mastertables`, {
      body: body,
      tableName: tableName,
      id: id,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating valid data ", error);
    throw error;
  }
}
